// window.cpSite.module.purchaseForm.vueCustomerForm = {
export default {
  name: 'customerForm',
  template: `
    <section>
      <h3 class="mt-0" v-if="fioAutoParse">Данные покупателя</h3>
      <h3 class="mt-0" v-else>Уточнение данных покупателя</h3>
      <el-form v-if="fioAutoParse" :model="customerForm" ref="customerForm" :label-width="isMobile?'':'220px'" class="mt-5">
        <el-form-item
          prop="email"
          label="Email"
          :rules="[
            { required: true, message: 'Электронная почта обязательна, на неё придёт письмо после оплаты', trigger: 'blur' },
            { type: 'email', message: 'Пожалуйста, укажите действительную электронную почту', trigger: ['blur', 'change'] }
          ]"
        >
         <el-input placeholder="Электронная почта" v-model="customerForm.email" :style="isMobile?'':'width:300px'"></el-input>
        </el-form-item>
        <el-form-item 
          prop="fio"
          label="Ф.И.О."
          class="mb-2"
          :rules="[
            { required: true, message: 'Указание Ф.И.О. покупателя обязательно', trigger: 'blur' },
            {
              pattern: /^[А-Яа-яЁёIV\\-\\s\\.\\',\\(\\)]+$/,
              message: 'Использованы недопустимые символы',
              trigger: 'blur'
            }
          ]"
        >
          <el-input @input="normalizeApostrophes($event,customerForm,'fio')" placeholder="Фамилия Имя Отчество" v-model="customerForm.fio" :style="isMobile?'':'width:300px'"></el-input>
        </el-form-item>
        
        <el-form-item
          prop="licenseOwner"
          :class="customerForm.isLicenseOwner ? 'mb-0' : ''"
          :rules="[
              {
                validator: (rule, value, callback) => {
                  if (!customerForm.isLicenseOwner && value === '') {
                    callback(new Error('Необходимо указать конечного пользователя'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change'
              }
            ]"
        >
          <el-checkbox v-model="customerForm.isLicenseOwner">
            Плательщик и конечный пользователь одно лицо
          </el-checkbox>
          <template v-if="!customerForm.isLicenseOwner">
            <div class="fs-13 text-start text-wrap text-break" style="line-height: 20px;"><i>Пользователь будет указан в лицензии:</i></div>
            <el-input type="text" placeholder="Наименование конечного пользователя" v-model="customerForm.licenseOwner" :style="isMobile?'':'width:300px'"></el-input>
          </template>
        </el-form-item>
        <el-form-item 
          prop="policyAccepted"
          :rules="[
            { 
              validator: (rule, value, callback) => {
                if (value === false) {
                  callback(new Error('Согласие обязательно'));
                } else {
                  callback();
                }
              }, 
              trigger: 'change'
            }
          ]"
        >        
          <el-checkbox v-model="customerForm.policyAccepted">
            Согласие на передачу информации
            <el-popover
              placement="top-start"
              width="274"
              popper-class=""
              visible-arrow="false"
              trigger="hover">
              <div class="p-2 text-start text-wrap text-break">Я подтверждаю своё согласие на передачу информации (в том числе персональных данных) в электронной форме в ООО «КРИПТО-ПРО» и дальнейшую её обработку в соответствии с законодательством Российской Федерации.</p><p class="mb-0"><a href="/privacy-policy" target="_blank">Политика обработки данных</a></div>
              <span slot="reference"> <i class="el-icon-info text-primary"></i></span>
            </el-popover>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button :size="isMobile?'mini':''" icon="el-icon-back" @click="$emit('stepDown')">Назад</el-button>
          <el-button :size="isMobile?'mini':''" icon="el-icon-close" @click="$emit('dialog',false)">Отмена</el-button>
          <el-button :size="isMobile?'mini':''" type="primary" @click="submitCustomerForm()">Продолжить оформление</el-button>
        </el-form-item>
      </el-form>      
      <el-form v-else :model="splitNameForm" ref="splitNameForm" :label-width="isMobile?'':'220px'" class="mt-5">
        <el-form-item 
          prop="surname"
          label="Фамилия" 
          :rules="[
            { required: true, message: 'Фамилия покупателя обязательна', trigger: 'blur' },
            {
              pattern: /^[А-Яа-яЁёIV\\-\\s\\.\\',\\(\\)]+$/,
              message: 'Использованы недопустимые символы',
              trigger: 'blur'
            }
          ]"
        >
          <el-input @input="normalizeApostrophes($event,splitNameForm,'surname')" placeholder="Фамилия" v-model="splitNameForm.surname" :style="isMobile?'':'width:300px'"></el-input>
        </el-form-item>   
        <el-form-item 
          prop="name"
          label="Имя" 
          :rules="[
            { required: true, message: 'Имя покупателя обязательно', trigger: 'blur' },
            {
              pattern: /^[А-Яа-яЁёIV\\-\\s\\.\\',\\(\\)]+$/,
              message: 'Использованы недопустимые символы',
              trigger: 'blur'
            }
          ]"
        >
          <el-input @input="normalizeApostrophes($event,splitNameForm,'name')" placeholder="Имя" v-model="splitNameForm.name" :style="isMobile?'':'width:300px'"></el-input>
        </el-form-item>
        <el-form-item 
          prop="patronymic"
          label="Отчество"
          :rules="[
            { required: customerForm.isRequiredPatronymic, message: 'Отчество покупателя обязательно', trigger: 'blur' },
            {
              pattern: /^[А-Яа-яЁёIV\\-\\s\\.\\',\\(\\)]+$/,
              message: 'Использованы недопустимые символы',
              trigger: 'blur'
            }
          ]"
        >
          <el-input :disabled="!customerForm.isRequiredPatronymic" @input="normalizeApostrophes($event,splitNameForm,'patronymic')" placeholder="Отчество" v-model="splitNameForm.patronymic" :style="isMobile?'':'width:300px'">
            
            <template slot="suffix">
            <el-tooltip content="У вас нет отчества?" placement="top-start">
              <i
                style="cursor: pointer"
                class="el-icon-close el-input__icon"
                @click="splitNameForm.patronymic = ''; customerForm.isRequiredPatronymic = !customerForm.isRequiredPatronymic; $refs.splitNameForm.clearValidate()">
              </i>
            </el-tooltip>
            </template>
            
          </el-input>
        </el-form-item>      
        <el-form-item>
          <el-button :size="isMobile?'mini':''" icon="el-icon-back" @click="returnToFioAutoParse()">Назад</el-button>
          <el-button :size="isMobile?'mini':''" icon="el-icon-close" @click="$emit('dialog',false)">Отмена</el-button>
          <el-button :size="isMobile?'mini':''" type="primary" @click="submitSplitNameForm()">Продолжить оформление</el-button>
        </el-form-item>
      </el-form>      
    </section>
  `,
  props: {
    isMobile: Boolean
  },
  data () {
    return {
      customerForm: {
        email: '',
        fio: '',
        isLicenseOwner: true,
        licenseOwner: '',
        policyAccepted: false,
        isRequiredPatronymic: true
      },
      splitNameForm: {
        surname: '',
        name: '',
        patronymic: ''
      },
      fioAutoParse: true
    }
  },
  methods: {
    // Первое заполнение
    submitCustomerForm () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          this.preparationCustomerFormData()
        } else {
          return false
        }
      })
    },
    // Дополнительное ручное заполнение отдельных полей Ф. И. О.
    submitSplitNameForm () {
      this.$refs.splitNameForm.validate((valid) => {
        if (valid) {
          // Ручное заполнение не проверяется, наличия заполненных полей достаточно для валидации и отправки
          this.$emit('customerData', this.manualDataToResult())
        } else {
          return false
        }
      })
    },
    async preparationCustomerFormData () {
      const dadata = await this.suggest(this.customerForm.fio)
      /**
       * dadata.result
       * {
       *   "suggestions":
       *   [{
       *     "value": "Петров Василий Павлович",
       *     "unrestricted_value": "Петров Василий Павлович",
       *     "data": {
       *       "surname": "Петров",
       *       "name": "Василий",
       *       "patronymic": "Павлович",
       *       "gender": "MALE",
       *       "source": null,
       *       "qc": "0"
       *     }
       *   }]
       * }
       */

      // Очистка
      this.splitNameForm = {
        surname: '',
        name: '',
        patronymic: ''
      }

      if (!dadata.ok) {
        /**
         * Сервис dadata не отвечает на запросы
         * Переходим на ручное заполнение
         */
        this.fioAutoParse = false
        return false
      }
      // Вернулось множество вариантов или пустой массив suggestions
      try {
        if (dadata.result.suggestions.length !== 1) {
          this.preparationDataToResult(dadata)
          this.fioAutoParse = false
          return false
          // qc=1 - Нет уверенности в предложенном варианте разложения ФИО
        } else if (+dadata.result.suggestions[0].data.qc !== 0) {
          this.preparationDataToResult(dadata)
          this.fioAutoParse = false
          return false
          // Возможен случай qc=0 и name: null - Абв !?
          // Проверка обязательного наличия отчества
        } else if (!dadata.result.suggestions[0].data.name || !dadata.result.suggestions[0].data.patronymic) {
          this.preparationDataToResult(dadata)
          this.fioAutoParse = false
          return false
        }
        this.$emit('customerData', this.preparationDataToResult(dadata))
      } catch (e) {
        this.fioAutoParse = false
        return false
      }
    },
    preparationDataToResult (dadata) {
      // Применить рекомендацию dadata
      const data = dadata.result.suggestions[0].data

      this.splitNameForm = {
        surname: data.surname,
        name: data.name,
        patronymic: data.patronymic
      }
      // Отправить итог в головной компонент
      this.updateFullName()
      const result = {
        ...this.customerForm,
        ...this.splitNameForm
      }
      return result
    },
    manualDataToResult () {
      // Отправить итог в головной компонент
      this.updateFullName()
      const result = {
        ...this.customerForm,
        ...this.splitNameForm
      }
      return result
    },
    updateFullName () {
      this.customerForm.fio = [this.splitNameForm.surname, this.splitNameForm.name, this.splitNameForm.patronymic]
        .filter(part => part) // Игнорируем пустые/ложные значения
        .join(' ') // Объединяем через пробел
    },
    // Проверка ФИО через dadata
    async suggest (fio) {
      const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio'
      const token = '999e903a6338d6c61e5f4c40020bebc3a9a7079a'

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Token ' + token
        },
        body: JSON.stringify({ query: fio })
      }
      try {
        const response = await fetch(url, options)
        const result = await response.json()
        return { ok: true, result }
      } catch (error) {
        return { ok: false, error }
      }
    },
    returnToFioAutoParse () {
      this.fioAutoParse = true
      this.$refs.splitNameForm.clearValidate()
    },
    normalizeApostrophes (value, el, elName) {
      // Символы, которые часто путают с апострофом
      const wrongApostrophes = /[’‘`´]/g
      // Заменяем их на стандартный апостроф (U+0027)
      el[elName] = value.replace(wrongApostrophes, "'")
    }
  },
  watch: {
    customerForm: {
      handler (newVal, oldVal) {
        sessionStorage.setItem('smartBuyCustomer', JSON.stringify(newVal))
      },
      deep: true // отслеживает вложенные изменения
    },
    splitNameForm: {
      handler (newVal, oldVal) {
        const data = {
          ...this.customerForm,
          fio: [this.splitNameForm.surname, this.splitNameForm.name, this.splitNameForm.patronymic].filter(part => part).join(' '),
          ...newVal
        }
        sessionStorage.setItem('smartBuyCustomer', JSON.stringify(data))
      },
      deep: true // отслеживает вложенные изменения
    }
  },
  mounted () {
    const jsonData = sessionStorage.getItem('smartBuyCustomer')
    try {
      const smartBuyOrder = JSON.parse(jsonData)
      if (smartBuyOrder.email) {
        this.customerForm = smartBuyOrder
        this.splitNameForm = {
          surname: smartBuyOrder.surname,
          name: smartBuyOrder.name,
          patronymic: smartBuyOrder.patronymic
        }
      }
    } catch (e) {}
  }
}
